'use strict';

var _ = require('lodash');
var AnalysisChartHistoricalTransformerFactory = function AnalysisChartHistoricalTransformerFactory(DataTransformer, momentService) {
  function AnalysisChartTransformer() {
    DataTransformer.call(this);
    this.sourceType = ['seasonality-analysis-chart-historical', 'seasonality-analysis-chart-historical-pooled', 'seasonality-analysis-chart-future', 'seasonality-analysis-chart-future-pooled'];
    this.targetType = ['seasonality-analysis-chart-historical', 'seasonality-analysis-chart-historical-pooled', 'seasonality-analysis-chart-future', 'seasonality-analysis-chart-future-pooled'];
    this.priority = 1;
  }
  AnalysisChartTransformer.prototype = Object.create(DataTransformer.prototype);
  AnalysisChartTransformer.constructor = AnalysisChartTransformer;
  AnalysisChartTransformer.prototype.canTransform = function (sourceType, targetType) {
    if (this.sourceType.indexOf(sourceType) > -1 && this.targetType.indexOf(targetType) > -1) {
      this.currentSourceType = sourceType;
      this.currentTargetType = targetType;
      return true;
    }
    return false;
  };
  AnalysisChartTransformer.prototype.isCacheable = function () {
    return false;
  };
  AnalysisChartTransformer.prototype.getCacheKey = function () {
    return this.currentSourceType + '-' + this.currentTargetType;
  };
  function correctOverrides(overrides) {
    _.forEach(overrides, function (override) {
      override.classGroup = override.classGroup || null;
      override.significantPOS = override.significantPOS || null;
      override.year = override.year || undefined;
    });
    return overrides;
  }
  function formatEventMarket(market) {
    return _.includes(market, '-') ? market : market.substring(0, 3) + '-' + market.substring(3);
  }
  function transformSpecialEvents(specialEvents) {
    return _.map(specialEvents, function (specialEvent) {
      return {
        eventName: specialEvent.eventName,
        eventType: specialEvent.eventType,
        market: formatEventMarket(specialEvent.market),
        endDate: momentService.of(specialEvent.endDepartureDate, momentService.FIELD.DEPARTURE_DATE),
        startDate: momentService.of(specialEvent.startDepartureDate, momentService.FIELD.DEPARTURE_DATE)
      };
    });
  }
  AnalysisChartTransformer.prototype.transform = function (data) {
    var results = [];
    for (var i = 0, length = data.domain.analysis.length; i < length; i++) {
      var entry = data.domain.analysis[i];
      var newEntry = {
        carrier: entry.carrier,
        market: entry.origin + '-' + entry.destination,
        origin: entry.origin,
        destination: entry.destination,
        domainName: entry.domainName,
        calendarName: entry.calendarName,
        seasonalityLevel: entry.seasonalityLevel,
        createdAt: momentService.of(entry.createdAt, momentService.FIELD.CREATED_AT),
        createdBy: entry.createdBy,
        updatedAt: momentService.of(entry.updatedAt, momentService.FIELD.UPDATED_AT),
        updatedBy: entry.updatedBy,
        startDepartureDate: momentService.of(entry.startDepartureDate, momentService.FIELD.DEPARTURE_DATE),
        endDepartureDate: momentService.of(entry.endDepartureDate, momentService.FIELD.DEPARTURE_DATE),
        outlierTolerance: entry.outlierTolerance,
        outliers: entry.outliers,
        outputs: entry.outputs,
        dowGroups: entry.dowGroups,
        minOptimalSeasons: entry.minOptimalSeasons,
        maxOptimalSeasons: entry.maxOptimalSeasons,
        optimalSeasonCutoffCV: entry.optimalSeasonCutoffCV,
        seasonalityVariable: entry.seasonalityVariable,
        smoothingNumberOfWeeks: entry.smoothingNumberOfWeeks,
        seasonalityOverrides: correctOverrides(entry.seasonalityOverrides),
        specialEvents: transformSpecialEvents(entry.specialEvents)
      };
      results.push(newEntry);
    }
    return results;
  };
  return AnalysisChartTransformer;
};
AnalysisChartHistoricalTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = AnalysisChartHistoricalTransformerFactory;